module.exports = __webpack_public_path__ + "front/img/slogan01.8e9ed9c5.png";